<ngx-loading [show]="isLoading"></ngx-loading>
<header
  class="flex flex-row items-center justify-between -mt-6 mb-0 -mx-6 px-6 h-20 min-h-20 text-white bg-accent-700"
  mat-dialog-title
  style="overflow: hidden"
>
  <div class="flex flex-row items-center">
    <button [mat-dialog-close]="true" class="close-button" mat-icon-button>
      <mat-icon
        [svgIcon]="'heroicons_solid:chevron-left' | transloco"
        class="close-icon"
      ></mat-icon>
    </button>
    <mat-icon class="icon-size-7 text-current" svgIcon="speaker_notes"></mat-icon>
    <div class="ms-3 text-2xl font-semibold tracking-tight">
      {{ 'add observation' | transloco }}
    </div>
  </div>
</header>

<!-- ADD -->
<ng-container>
  <div
    [class.is-loading]="isLoading || (isLoadingCustomFields$ | async)"
    class="dark w-auto bg-accent-900"
    mat-dialog-content
    style="overflow-x: hidden"
  >
    <!--    <button mat-stroked-button color="primary" style="border-radius: 15px;padding-top: 28px; position: fixed; cursor: pointer; border:none"-->
    <!--            (click)="getBinaryScreenShotFile();"><mat-icon>refresh</mat-icon>-->
    <!--    </button>-->
    <form *ngIf="isComponentReady()" [formGroup]="observationForm" class="example-form">
      <div class="flex flex-col w-full">
        <div class="mt-3">
          <!--Screenshot-->
          <div class="flex flex-row justify-center" id="screenshot">
            <div class="w-full max-w-72 relative" style="max-width: 300px">
              <!--              <span-->
              <!--                [ngClass]="-->
              <!--                  translocoService.getActiveLang() === 'ar' ? '-left-4 -top-1' : '-right-4 -top-1'-->
              <!--                "-->
              <!--                class="text-warn-500 font-bold text-2xl absolute z-10"-->
              <!--                >*</span-->
              <!--              >-->
              <div
                *ngIf="screenShotImage"
                class="border border-accent-500 rounded-md bg-accent-800 p-1"
                style="position: relative"
              >
                <img
                  (click)="fileAttached.click()"
                  [src]="screenShotImage"
                  alt=""
                  class="rounded-md"
                />
                <button
                  (click)="removeImg()"
                  class="absolute top-2 right-2"
                  mat-icon-button
                  type="button"
                >
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
              </div>
              <button
                (click)="fileAttached.click()"
                *ngIf="!screenShotImage"
                [ngClass]="
                  observationForm?.get('screen_shot')?.invalid
                    ? 'border-primary'
                    : 'border-accent-500'
                "
                class="border rounded-md bg-accent-800 border-dashed w-full p-1 relative"
                type="button"
              >
                <img alt="" class="rounded-md" [src]="screenshotPlaceholderPath" />
                <div class="flx-col justify-center items-center absolute-x-center bottom-3">
                  <div class="light bg-transparent text-secondary font-bold">
                    {{ 'No Image Yet' | transloco }}<br />
                  </div>
                </div>
              </button>
              <input
                #fileAttached
                (change)="fileChangeEvent($event)"
                [formControlName]="'screen_shot'"
                accept="image/*"
                class="hidden"
                type="file"
              />
              <mat-error *ngIf="observationForm?.get('screen_shot')?.invalid" class="text-center">{{
                'Image is required' | transloco
              }}</mat-error>
            </div>
          </div>

          <div class="w-auto">
            <mat-form-field class="w-full">
              <mat-label class="text-primary">{{ 'title' | transloco }}</mat-label>
              <input
                [placeholder]="'Write the tittle ...' | transloco"
                formControlName="title"
                matInput
                [maxlength]="titleMaxLength"
              />
              <small class="text-secondary whitespace-nowrap px-1"
                >{{ observationForm?.get('title')?.value?.length || 0 }} /
                {{ titleMaxLength }}</small
              >
            </mat-form-field>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'description' | transloco }}
                <span
                  *ngIf="nwc_client"
                  [ngClass]="{
                    'text-warn-500':
                      observationForm?.get('description')?.invalid &&
                      observationForm?.get('description')?.dirty,
                    'text-white':
                      !observationForm?.get('description')?.invalid ||
                      !observationForm?.get('description')?.dirty
                  }"
                  class="font-bold text-lg ml-1"
                  >*</span
                >
              </label>
              <quill-editor
                #descriptionEditor
                [formControlName]="'description'"
                [placeholder]="'Write the description' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'description')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div
                class="text-sm text-gray-500 mt-1 text-end"
                *ngIf="!isLoading && maxQuillDescriptionLength !== null"
              >
                {{ getDescriptionCharCount() }}/{{ maxQuillDescriptionLength }}
                {{ 'characters' | transloco }}
              </div>
              <mat-error
                *ngIf="
                  observationForm?.get('description')?.invalid &&
                  observationForm?.get('description')?.touched
                "
              >
                {{ 'Description is required' | transloco }}
              </mat-error>
            </div>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'Recommended Corrective Action' | transloco }}
              </label>
              <quill-editor
                #recommendedActionEditor
                [formControlName]="'recommended_corrective_action'"
                [placeholder]="'Write the recommended corrective action' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'recommendedAction')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div
                class="text-sm text-gray-500 mt-1 text-end"
                *ngIf="!isLoading && maxQuillRecommendedActionLength !== null"
              >
                {{ getRecommendedActionCharCount() }}/{{ maxQuillRecommendedActionLength }}
                {{ 'characters' | transloco }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex sm:flex-row gap-2 flex-col justify-between items-stretch mb-3">
          <div class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-category' | transloco }} </mat-label>
              <mat-select
                formControlName="categories"
                (selectionChange)="onCategorySelectionChange()"
                [multiple]="!nwc_client"
                [compareWith]="compareWithId"
                [disabled]="!!observationForm?.get('type') && !observationForm?.get('type')?.value"
              >
                <mat-option
                  (click)="setGoogleEvent('AddNewObservation_selectCatgry_project')"
                  *ngFor="let item of observationCategories"
                  [value]="item.id"
                >
                  {{ item?.category_name_en }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="w-full" *ngIf="shouldShowSubcategoryField()">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">
                {{ 'select-sub-category' | transloco }}
                <span class="text-warn-500 font-bold text-lg ml-1">*</span>
              </mat-label>
              <mat-select formControlName="child_categories" [multiple]="!nwc_client">
                <mat-option
                  (click)="setGoogleEvent('AddNewObservation_selectChildCatgry_project')"
                  *ngFor="let item of observationChildCategories"
                  [value]="item.id"
                >
                  {{ item?.category_name_en }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  observationForm?.get('child_categories')?.hasError('subcategoryRequired') &&
                  observationForm?.get('child_categories')?.touched
                "
              >
                {{ 'Sub-category is required' | transloco }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-users' | transloco }}</mat-label>
              <mat-select formControlName="users" multiple>
                <!-- Search input for selecting users -->
                <mat-option>
                  <ngx-mat-select-search
                    #singleSelect
                    [formControl]="searchControl"
                    [noEntriesFoundLabel]="'No result found' | transloco"
                    [placeholderLabel]="'Search' | transloco"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  (click)="setGoogleEvent('AddNewObservation_selectUser_project')"
                  *ngFor="let item of filteredUsers"
                  [value]="item.uuid"
                >
                  {{ item?.name | titlecase }}
                  <span class="text-secondary">({{ item.email }})</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="selectedType && isFieldVisible('due_date')" class="w-full sm:px-3 px-0">
            <mat-form-field *ngIf="!checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                (dateChange)="getDate($event.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-dd'"
                [ngxMatDatetimePicker]="picker"
                [placeholder]="'Choose a date' | transloco"
                matInput
                readonly
              />
              <mat-datepicker-toggle [for]="picker" matSuffix> </mat-datepicker-toggle>

              <ngx-mat-datetime-picker #picker (opened)="resetPicker()"> </ngx-mat-datetime-picker>
            </mat-form-field>

            <mat-form-field *ngIf="checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                #dateInput
                (change)="getDate($event.target.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-ddThh:mm'"
                [placeholder]="'Choose a date' | transloco"
                matInput
                type="datetime-local"
              />

              <mat-datepicker-toggle (click)="dateInput.click()" matSuffix> </mat-datepicker-toggle>
            </mat-form-field>
          </div>
        </div>

        <div class="grid grid-rows-3 grid-flow-col gap-2 sm:grid-rows-1">
          <div *ngIf="isFieldVisible('significance')">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'significance' | transloco }} </mat-label>
              <mat-select formControlName="significance">
                <mat-option
                  *ngFor="let significance of observationSignificances; index as i"
                  [value]="significance.value"
                >
                  {{
                    i === 0
                      ? ('Select significance' | transloco)
                      : (significance.label | removeUnderscore | titlecase | transloco)
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="isFieldVisible('type')">
            <section class="example-section">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label class="text-primary">{{ 'type' | transloco }} </mat-label>
                <mat-select formControlName="type" (selectionChange)="getType($event)">
                  <mat-option *ngFor="let type of observationTypes" [value]="type.value">
                    {{ type.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </section>
          </div>
          <div *ngIf="isFieldVisible('code')">
            <section class="example-section">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label class="text-primary">{{ 'Code' | transloco }}</mat-label>
                <mat-select formControlName="code">
                  <mat-option
                    *ngFor="let code of observationCodes; index as i"
                    [value]="code.value"
                  >
                    {{ code.label }}
                    <span *ngIf="i !== 0" class="ms-2 text-secondary"
                      >({{ code.description }})</span
                    >
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </section>
          </div>
        </div>
        <div *ngIf="isFieldVisible('privacy')">
          <section class="example-section">
            <mat-label class="text-primary">{{ 'privacy' | transloco }}</mat-label>
            <br />
            <div>
              <mat-radio-group [color]="'primary'" formControlName="privacy">
                <mat-radio-button
                  (click)="setGoogleEvent('AddNewObservation_PrivacyPublic_project')"
                  class="mt-2"
                  value="public"
                >
                  {{ 'public' | transloco }}
                </mat-radio-button>
                <span class="mx-2"></span>
                <mat-radio-button
                  (click)="setGoogleEvent('AddNewObservation_PrivacyPrivate_project')"
                  class="mx-2"
                  value="private"
                >
                  {{ 'private' | transloco }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </section>
        </div>

        <div class="w-full mt-3">
          <app-observation-hashtags
            [projectId]="data?.project_id"
            [selectedHashtagsArray]="observationHashtags"
            [isOptional]="true"
            (hashtagsEmitter)="onObservationHashtagsChange($event)"
          ></app-observation-hashtags>
        </div>

        <!-- Custom Fields Section -->
        <app-custom-fields-section
          [customFields$]="customFields$"
          [isLoadingCustomFields$]="isLoadingCustomFields$"
          [form]="observationForm ?? {}"
          [disabled]="isLoading"
        >
        </app-custom-fields-section>

        <section class="example-section mt-4">
          <mat-label class="text-primary">{{ 'Attachments' | transloco }}</mat-label>
          <br />
          <div class="w-full mb-3 mt-5">
            <app-file-uploader
              (filesList)="onAttachmentsChanged($event)"
              [multiple]="true"
              [options]="fileOptions"
            >
            </app-file-uploader>
            <p
              *ngIf="attachmentsError || isMissingRequiredAttachments"
              class="text-red-500 text-sm mt-1"
            >
              {{
                (attachmentsError ? attachmentsError : 'observation.attachments_required_for_type')
                  | transloco
              }}
            </p>
          </div>
        </section>
      </div>
    </form>
  </div>
  <mat-dialog-actions align="end" class="actions text-center bg-opacity-20">
    <!-- Debug button (temporary) -->
    <!-- <button
                      (click)="debugFormValidation(observationForm?.value)"
      mat-button
      class="mat-dense me-2"
      style="background-color: #ff9800; color: white"
    >
      🔍 Debug Form
    </button> -->

    <button type="button" mat-button mat-dialog-close>{{ 'cancel' | transloco }}</button>
    <button
      type="button"
      (click)="onSubmit(true)"
      [disabled]="
        !observationForm?.value?.title?.trim() ||
        !observationForm?.value?.type ||
        isLoading ||
        (isLoadingCustomFields$ | async)
      "
      mat-raised-button
      class="mat-dense mx-2"
    >
      {{ 'Save Draft' | transloco }}
    </button>
    <button
      type="button"
      (click)="onSubmit(false)"
      [disabled]="
        !observationForm?.valid ||
        isLoading ||
        (isLoadingCustomFields$ | async) ||
        !observationForm?.value?.title?.trim() ||
        isMissingRequiredAttachments
      "
      color="primary"
      mat-raised-button
      type="submit"
      class="mat-dense"
    >
      {{ 'Publish' | transloco }}
    </button>
  </mat-dialog-actions>
</ng-container>
